export default "__VITE_ASSET__1GFXEi0a__"